module.exports = __webpack_public_path__ + "img/Redis.6f7ca142.svg";